/**
 * 繁體中文翻譯
 * Traditional Chinese Translation
 */

const zhTWTranslations = {
  // 應用基礎資訊
  app: {
    title: '牛馬擺爛工具',
    subtitle: '加班時間管理系統',
    description: '專業的加班時間記錄與調休管理工具'
  },

  // 日期時間相關
  dateTime: {
    invalidDate: '無效日期',
    formatError: '日期格式錯誤'
  },

  // 通用詞彙
  common: {
    confirm: '確認',
    cancel: '取消',
    save: '儲存',
    delete: '刪除',
    edit: '編輯',
    copy: '複製',
    close: '關閉',
    loading: '載入中...',
    success: '成功',
    error: '錯誤',
    warning: '警告',
    info: '資訊',
    yes: '是',
    no: '否',
    ok: '好的',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    submit: '提交',
    reset: '重置',
    clear: '清空',
    search: '搜尋',
    filter: '篩選',
    sort: '排序',
    export: '匯出',
    import: '匯入',
    settings: '設定',
    help: '說明',
    about: '關於'
  },
  
  // 時間相關
  time: {
    startTime: '開始時間',
    endTime: '結束時間',
    duration: '時長',
    totalTime: '總時長',
    remainingTime: '剩餘時間',
    usedTime: '已用時間',
    availableTime: '可用時間',
    hours: '小時',
    minutes: '分鐘',
    days: '天',
    today: '今天',
    yesterday: '昨天',
    thisWeek: '本週',
    thisMonth: '本月',
    thisYear: '本年'
  },
  
  // 加班相關
  overtime: {
    title: '加班記錄',
    record: '錄入加班',
    startTime: '牛馬開始時間',
    endTime: '牛馬結束時間',
    duration: '加班時長',
    remaining: '剩餘可擺爛時間',
    total: '總加班時間',
    list: '加班記錄列表',
    details: '詳細記錄',
    consumption: '消耗記錄',
    edit: '編輯加班記錄',
    delete: '刪除加班記錄',
    copy: '複製記錄',
    
    // 表單驗證
    validation: {
      startTimeRequired: '請輸入牛馬的開始時間！',
      endTimeRequired: '請輸入牛馬的結束時間！',
      endTimeAfterStart: '牛馬結束時間必須大於開始時間！'
    },
    
    // 統計資訊
    stats: {
      totalHours: '本年度您已經牛馬了 {{hours}} 小時',
      remainingHours: '剩餘可擺爛時間 {{overtimeHours}}+{{annualLeaveHours}} 小時'
    }
  },
  
  // 調休相關
  rest: {
    title: '擺爛記錄',
    record: '申請擺爛',
    startTime: '擺爛開始時間',
    endTime: '擺爛結束時間',
    duration: '擺爛時長',
    type: '擺爛類型',
    compTime: '調休',
    list: '擺爛記錄列表',
    edit: '編輯擺爛記錄',
    delete: '刪除擺爛記錄',
    
    // 表單驗證
    validation: {
      startTimeRequired: '請輸入擺爛開始時間和結束時間！',
      endTimeRequired: '請輸入擺爛結束時間！',
      endTimeAfterStart: '擺爛結束時間必須大於開始時間！',
      insufficientTime: '剩餘時間不足以申請這麼多擺爛時間！',
      insufficientOvertimeTime: '剩餘牛馬時間不足以增加這麼多調休時間！'
    }
  },
  
  // 年假相關
  annualLeave: {
    title: '年假管理',
    totalDays: '年假總天數',
    usedHours: '已用小時',
    remainingHours: '剩餘小時',
    record: '年假記錄',
    set: '設定年假',
    edit: '編輯年假記錄',
    delete: '刪除年假記錄',
    
    // 設定對話框
    settings: {
      title: '設定年假',
      totalDaysLabel: '年假總天數',
      totalDaysPlaceholder: '請輸入年假總天數',
      note: '注意：年假按每天8小時計算'
    }
  },
  
  // 計算規則
  rules: {
    title: '計算規則說明',
    overtime: {
      title: '加班計算規則',
      description: '按連續時間計算，包含午休時間',
      example: '例如：{{timeRange}} = {{result}}',
      note: '加班時間按實際連續時間計算，不扣除午休'
    },
    rest: {
      title: '調休計算規則',
      description: '按工作日計算，扣除午休時間',
      example: '例如：{{timeRange}} = {{result}}（{{note}}）',
      note: '扣除1小時午休',
      workingHours: '工作時間：9:00-18:00（扣除12:00-13:00午休）'
    },
    annualLeave: {
      title: '年假計算規則',
      description: '年假按每天8小時計算',
      example: '1天年假 = 8小時'
    }
  },
  
  // 資料管理
  data: {
    save: '儲存資料到本地',
    load: '載入備份資料',
    export: '匯出資料',
    import: '匯入資料',
    backup: '備份資料',
    restore: '還原資料',
    clear: '清空資料',
    
    // 訊息提示
    messages: {
      saveSuccess: '資料儲存成功',
      loadSuccess: '資料已成功匯入並更新',
      exportSuccess: '資料匯出成功',
      importSuccess: '資料匯入成功',
      clearSuccess: '資料清空成功',
      parseError: '無法解析匯入的檔案。請確保它是有效的格式。',
      newerDataWarning: '匯入的資料比本地存的資料舊。是否仍要覆蓋本地資料？',
      cleanupComplete: '清理完成，共移除 {{count}} 條冗餘記錄。'
    }
  },
  
  // 表格相關
  table: {
    index: '序號',
    number: '序號',
    type: '類型',
    startTime: '開始時間',
    endTime: '結束時間',
    duration: '時長',
    remaining: '剩餘時間',
    remainingTime: '剩餘可擺爛時間',
    actions: '操作',
    details: '詳細記錄',
    expand: '展開',
    collapse: '收起',
    noData: '暫無資料',
    consumptionRecords: '擺爛消耗記錄',
    restRequestStartTime: '擺爛申請開始時間',
    restRequestEndTime: '擺爛申請結束時間',
    actualConsumptionStartTime: '實際消耗開始時間',
    actualConsumptionEndTime: '實際消耗結束時間',
    deductionTime: '擺爛扣除時間',
    annualLeaveStartTime: '年假開始時間',
    annualLeaveEndTime: '年假結束時間',

    // 分頁
    pagination: {
      total: '共 {{total}} 條',
      pageSize: '每頁顯示',
      items: '條',
      page: '頁'
    }
  },
  
  // 消費記錄
  consumption: {
    title: '擺爛消耗記錄',
    restStartTime: '擺爛申請開始時間',
    restEndTime: '擺爛申請結束時間',
    actualStartTime: '實際消耗開始時間',
    actualEndTime: '實際消耗結束時間',
    deductionTime: '擺爛扣除時間',
    type: '類型',
    
    // 複製報告
    copyReport: {
      overtimeDeduction: '扣除對應加班時間共（{{hours}}小時）',
      annualLeaveDeduction: '扣除年假時間共（{{hours}}小時）',
      copySuccess: '已複製到剪貼簿',
      copyFailed: '複製失敗，請重試'
    }
  },
  
  // 更新日誌
  updateLog: {
    title: '更新記錄',
    show: '顯示更新記錄',
    hide: '隱藏更新記錄',
    version: '版本',
    date: '日期',
    content: '更新內容'
  },
  
  // 語言設定
  language: {
    title: '語言設定',
    current: '目前語言',
    select: '選擇語言',
    change: '切換語言'
  },
  
  // 記錄相關
  records: {
    overtimeRecords: '牛馬記錄',
    restRecords: '擺爛記錄',
    annualLeaveRecords: '年假記錄',
    restType: '調休',
    annualLeaveType: '年假',
    annualLeave: '年假',
    rest: '擺爛',
    overtime: '牛馬'
  },

  // 分頁相關
  pagination: {
    previous: '上一頁',
    next: '下一頁',
    pageInfo: '第 {{current}} 頁，共 {{total}} 頁',
    itemsPerPage: '{{count}}條/頁'
  },

  // 複製功能
  copy: {
    deductOvertimeTotal: '加班調休,扣除對應加班時間共（{{hours}}小時）',
    deductAnnualLeaveTotal: '扣除年假時間共（{{hours}}小時）',
    annualLeaveTitle: '年假休假:',
    errorPrefix: '無法複製文字: '
  },

  // 統計資訊
  stats: {
    totalOvertime: '累計加班時間',
    availableOvertime: '可用加班時間',
    remainingAnnualLeave: '剩餘年假時間',
    totalRest: '已擺爛時間'
  },

  // 操作按鈕
  actions: {
    recordOvertime: '記錄加班',
    addOvertimeTime: '新增加班時間',
    requestRest: '申請調休',
    useOvertimeTime: '使用加班時間',
    setAnnualLeave: '設定年假',
    configureAnnualLeaveDays: '配置年假天數',
    saveData: '儲存資料',
    exportData: '匯出資料',
    importData: '匯入資料',
    cleanData: '清理資料'
  },

  // 訊息提示
  messages: {
    overtimeAdded: '加班記錄已新增',
    restAdded: '調休記錄已新增',
    overtimeDeleted: '加班記錄已刪除',
    restDeleted: '調休記錄已刪除',
    dataSaved: '資料已儲存',
    dataLoaded: '資料已載入',
    dataImported: '資料已匯入',
    dataExported: '資料已匯出',
    noLocalData: '沒有找到本地資料，使用預設資料',
    cleanupComplete: '清理完成，移除了 {{count}} 條冗餘記錄',
    overtimeRecordAdded: '加班記錄新增成功！',
    restRequestSubmitted: '調休申請提交成功！',
    pleaseCompleteTimeInfo: '請填寫完整的時間資訊',
    overtimeRecordUpdated: '加班記錄更新成功！',
    restRecordUpdated: '調休記錄更新成功！',
    annualLeaveRecordUpdated: '年假記錄更新成功！',
    copiedToClipboard: '已複製到剪貼簿',
    copyFailed: '複製失敗，請重試'
  },

  // 模態框
  modals: {
    recordOvertimeTitle: '記錄加班',
    requestRestTitle: '申請調休',
    setAnnualLeaveTitle: '🏖️ 設定年假天數',
    editOvertimeTitle: '修改牛馬記錄',
    editRestTitle: '修改擺爛記錄',
    editAnnualLeaveTitle: '修改年假記錄',
    recordOvertimeTimeTitle: '⏱️ 記錄加班時間',
    requestRestTimeTitle: '😴 申請調休時間'
  },

  // 表單
  forms: {
    currentAnnualLeave: '目前年假：',
    remainingTime: '剩餘時間：',
    customDays: '自訂天數：',
    enterDays: '輸入天數',
    noAnnualLeave: '無年假',
    annualLeaveStartTime: '年假開始時間:',
    annualLeaveEndTime: '年假結束時間:',
    overtimeStartTime: '牛馬開始時間:',
    overtimeEndTime: '牛馬結束時間:'
  },

  // 確認對話框
  confirmDialog: {
    deleteMessage: '確定要刪除這條記錄嗎？',
    cleanupMessage: '確定要清理冗餘資料嗎？此操作不可撤銷。',
    deleteRestMessage: '確定要刪除這條擺爛記錄？',
    deleteAnnualLeaveMessage: '確定要刪除這條年假記錄嗎？'
  },



  // 錯誤訊息
  errors: {
    networkError: '網路錯誤，請檢查網路連線',
    serverError: '伺服器錯誤，請稍後重試',
    unknownError: '未知錯誤，請聯絡管理員',
    validationError: '資料驗證失敗',
    permissionDenied: '權限不足',
    notFound: '未找到相關資料',
    timeout: '請求逾時，請重試'
  },

  // 主題相關
  theme: {
    toggle: '切換主題',
    modern: '現代風格',
    retro: '復古風格',
    sketch: '手繪風格',
    damaged: '戰損崩壞風',
    switchToModern: '切換到現代風格',
    switchToRetro: '切換到復古風格',
    switchToSketch: '切換到手繪風格',
    switchToDamaged: '切換到戰損崩壞風'
  }
};

export default zhTWTranslations;
